import api from './Axios';

// 1. Send OTP (Initial request)
export const sendOtp = (phone: string) =>
  api.post('/api/auth/send-otp', { phone });

// 2. Resend OTP (Alias for sendOtp)
// We export this separately so your button logic remains clear:
// <button onClick={handleResend}>Resend OTP</button>
export const resendOtp = (phone: string) =>
  api.post('/api/auth/send-otp', { phone });

// 3. Verify OTP
export const verifyOtp = (phone: string, otp: string) =>
  api.post('/api/auth/verify-otp', { phone, otp });